const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

export interface LoginResponse {
	accessToken: string;
	accessTokenExpiration: string;
	refreshToken: string;
	refreshTokenExpiration: string;
}

export interface RefreshTokenResponse {
	accessToken: string;
	accessTokenExpiration: string;
}

export interface ApiError {
	message: string;
	code?: string;
}

/**
 * Login with securedId
 */
export async function loginWithSecuredId(securedId: string): Promise<LoginResponse> {
	const response = await fetch(`${API_BASE_URL}/auth/login`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ securedId }),
	});

	if (!response.ok) {
		const error: ApiError = await response.json().catch(() => ({
			message: response.statusText || 'Authentication failed',
		}));

		throw new Error(error.message || 'Authentication failed');
	}

	return response.json();
}

export async function refreshAccessToken(refreshToken: string, signal?: AbortSignal): Promise<RefreshTokenResponse> {
	const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ refreshToken }),
		signal,
	});

	if (!response.ok) {
		const error: ApiError = await response.json().catch(() => ({
			message: response.statusText || 'Token refresh failed',
		}));

		throw new Error(error.message || 'Token refresh failed');
	}

	return response.json();
}
